import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { MvTilesetsComponent } from "./components/mv-tilesets/mv-tilesets.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { GameDetailComponent } from "./components/game-detail/game-detail.component";
import { TestComponent } from "./components/test/test.component";
import { ContactComponent } from "./components/contact/contact.component";
import { SoftwareComponent } from "./components/software/software.component";

const routes: Routes = [
  { path: "", component: DashboardComponent },
  { path: "mv-tilesets", component: MvTilesetsComponent },
  { path: "engine-free", component: MvTilesetsComponent },
  { path: "games/:name", component: GameDetailComponent },
  { path: "apps/:name", component: SoftwareComponent },
  { path: "contact", component: ContactComponent },
  { path: "test", component: TestComponent },
  { path: "**", redirectTo: "" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
